import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const BackButtonHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handlePopState = (event) => {
      if (location.pathname !== "/") {
        navigate("/", { replace: true });
      } else {
        // Si ya está en Home, bloqueamos el retroceso (evita volver atrás del home)
        window.history.pushState(null, "", window.location.href);
      }
    };

    // Escuchamos cuando el usuario presiona el botón atrás
    window.addEventListener("popstate", handlePopState);

    // Forzamos un nuevo estado al cargar (para que Home tenga un "estado base")
    window.history.pushState(null, "", window.location.href);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [location.pathname, navigate]);
  return null;
};

export default BackButtonHandler;